export class cRelatedProductsTags {

  constructor() {
    const tags    = document.querySelector('.c-tags')                      as HTMLElement;
    const gallery = document.querySelector('.woocommerce-product-gallery') as HTMLElement;
    if (gallery === null) return;

    // The tags are rendered into the gallery wrapper (woocommerce_product_thumbnails). With gallery images
    // FlexSlider puts that wrapper into an overflow: hidden viewport, so move the tags below the thumbnails.
    jQuery(gallery).on('wc-product-gallery-after-init', () => {
      gallery.append(tags);
    });
  }
}
